import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@icon/backlog-icon.svg'


const _hoisted_1 = { class: "label-pic is-orange" }
const _hoisted_2 = { class: "notification__item-content__icon" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "notification__unprioritized-add-item__title notification__item-content__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_SeverityLevelIcon = _resolveComponent("SeverityLevelIcon")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, { notification: _ctx.notification }, {
    pic: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_icon, {
          data: _imports_0,
          class: "label-pic__icon",
          fill: true,
          width: "var(--icon-24)",
          height: "var(--icon-24)",
          color: "#F57C00"
        })
      ])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Support Case " + _toDisplayString(_ctx.wasSupportCaseFromActiveSprint ? "was added to Active Sprint" : "Created"), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400",
        className: "notification__unprioritized-add-item notification__item-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_SeverityLevelIcon, {
              level: _ctx.notification.getItemValue('severityLevel')
            }, null, 8, ["level"])
          ]),
          _createElementVNode("a", {
            class: "link is-medium-500",
            target: "_blank",
            href: _ctx.notification.itemUrl
          }, _toDisplayString(_ctx.notification.itemSequenceNumber), 9, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.notification.getItemValue("title")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["notification"]))
}